(() => {
  if (customElements.get('fb-gift-offer')) return;
  const root = window.Shopify?.routes?.root || '/';
  const giftCode = 'FBREGENTGIFT';
  let busy = false;
  let timer;
  const selectionEvent = 'fb:gift-selection';
  const sharedSelection = window.FerobrillGiftSelection || (window.FerobrillGiftSelection = {handle: '', variantId: ''});
  const broadcastSelection = (source, handle, variantId = '') => {
    sharedSelection.handle = handle || '';
    sharedSelection.variantId = variantId ? String(variantId) : '';
    document.dispatchEvent(new CustomEvent(selectionEvent, {detail: {source, handle: sharedSelection.handle, variantId: sharedSelection.variantId}}));
  };
  const isGift = item => item.properties?._fb_regent_gift === '1';
  const eligibleTotal = cart => cart.items.reduce((total, item) => total + (!isGift(item) && !item.gift_card ? item.original_line_price : 0), 0);
  const request = async (path, body) => {
    const response = await fetch(`${root}${path}`, body === undefined ? {headers: {Accept: 'application/json'}} : {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error('Cart request failed');
    return data;
  };
  const refresh = async () => {
    const page = location.pathname.replace(/\/$/, '') === `${root}cart` ? `${root}cart` : root;
    const response = await fetch(`${page}?section_id=helper-cart`);
    if (!response.ok) throw new Error('Cart refresh failed');
    const text = await response.text();
    if (typeof window.renderHelperCart === 'function') window.renderHelperCart(text);
    else window.location.reload();
  };
  const removeGifts = async cart => {
    const updates = Object.fromEntries(cart.items.filter(isGift).map(item => [item.key, 0]));
    if (Object.keys(updates).length) return request('cart/update.js', {updates});
    return cart;
  };
  const hasFreeGift = cart => cart.items.some(item => isGift(item) && item.quantity === 1 && item.final_line_price === 0);
  const reconcile = async () => {
    if (busy || !document.querySelector('fb-gift-offer[data-gift-in-cart="true"]')) return;
    busy = true;
    try {
      const cart = await request('cart.js');
      if (cart.items.some(isGift) && (eligibleTotal(cart) < 22500 || !hasFreeGift(cart) || cart.items.filter(isGift).length > 1)) {
        await removeGifts(cart);
        await refresh();
      }
    } catch (error) { console.warn('Complimentary T-shirt cart check could not complete.'); }
    finally { busy = false; }
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(reconcile, 250); };
  const cartForm = document.getElementById('AjaxCartForm');
  if (cartForm) new MutationObserver(schedule).observe(cartForm, {childList: true, subtree: true});
  document.addEventListener('cart-updated', schedule, true);
  schedule();
  const previewProducts = new Map();
  const previewImage = (value, width = 1000) => {
    try {
      const url = new URL(typeof value === 'string' ? value : value?.src, location.origin);
      if (url.protocol !== 'https:') return '';
      url.searchParams.set('width', String(width));
      return url.href;
    } catch { return ''; }
  };
  const giftDescriptionSections = (html, title) => {
    const documentCopy = new DOMParser().parseFromString(html || '', 'text/html');
    documentCopy.querySelectorAll('br').forEach(line => line.replaceWith(document.createTextNode('\n')));
    const sections = {description:[],details:[],composition:[],materials:[],care:[]};
    const headings = {'DESCRIPTION':'description','DETAILS':'details','FABRIC COMPOSITION':'composition','MATERIALS':'materials','CARE':'care','COORDINATES':'ignore','SIZE GUIDE':'ignore','DELIVERY & RETURNS':'ignore'};
    let current = 'description';
    for (const node of documentCopy.body.querySelectorAll('p,li,h1,h2,h3,h4,h5,h6')) {
      if (node.parentElement.closest('p,li')) continue;
      const text = node.textContent.trim();
      const heading = text.replace(/\s+/g,' ').toUpperCase();
      if (headings[heading]) {current = headings[heading];continue;}
      if (!text || /^H[1-6]$/.test(node.tagName) || heading === String(title || '').toUpperCase() || current === 'ignore') continue;
      sections[current].push(text.replace(/^[–—\-⛬\s]+/,''));
    }
    return sections;
  };
  class GiftPreview {
    constructor(offer, catalog, onAdd) {
      this.offer = offer;
      this.catalog = catalog;
      this.onAdd = onAdd;
      this.sequence = 0;
      offer.querySelectorAll('[data-fb-gift-view]').forEach(trigger => trigger.addEventListener('click', () => this.open(trigger)));
    }
    create() {
      if (this.dialog?.isConnected) return;
      const template = this.offer.querySelector('[data-fb-gift-preview-template]');
      if (!template) return;
      this.dialog = template.content.firstElementChild.cloneNode(true);
      document.body.append(this.dialog);
      this.gallery = this.dialog.querySelector('[data-fb-preview-gallery]');
      this.media = this.dialog.querySelector('[data-fb-preview-media]');
      this.status = this.dialog.querySelector('[data-fb-preview-status]');
      this.loadingText = this.status.textContent;
      this.counter = this.dialog.querySelector('[data-fb-preview-count]');
      this.zoom = this.dialog.querySelector('[data-fb-preview-zoom]');
      this.previous = this.dialog.querySelector('[data-fb-preview-prev]');
      this.next = this.dialog.querySelector('[data-fb-preview-next]');
      this.dialog.querySelectorAll('[data-fb-preview-close]').forEach(button => button.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('cancel', event => {event.preventDefault(); this.close();});
      this.dialog.addEventListener('click', event => {if (event.target === this.dialog) this.close();});
      this.dialog.addEventListener('close', () => this.restore());
      this.dialog.querySelectorAll('[data-fb-preview-section] > summary').forEach(summary => {
        summary.addEventListener('click', event => {
          event.preventDefault();event.stopPropagation();
          const panel = summary.parentElement;panel.open = !panel.open;
        });
      });
      this.gallery.addEventListener('scroll', () => this.updateCount(), {passive:true});
      this.gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          if (this.media.classList.contains('is-zoomed')) return;
          event.preventDefault();this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.zoom.addEventListener('click', () => {
        const zoomed = this.media.classList.toggle('is-zoomed');
        this.zoom.setAttribute('aria-pressed', String(zoomed));
        const slide = this.gallery.children[this.index || 0];
        const image = slide?.querySelector('img');
        if (image && zoomed) image.src = previewImage(image.src, 1800);
        if (slide && !zoomed) slide.scrollTo(0,0);
      });
      const handle = this.dialog.querySelector('.fb-gift-preview__handle');
      handle.addEventListener('pointerdown', event => {this.dragStart = event.clientY;handle.setPointerCapture?.(event.pointerId);});
      handle.addEventListener('pointerup', event => {if (event.clientY - this.dragStart > 60) this.close();this.dragStart = null;});
      this.size = this.dialog.querySelector('[data-fb-preview-size]');
      this.add = this.dialog.querySelector('[data-fb-preview-add]');
      this.size.addEventListener('change', () => {
        this.sizeValue = this.member.variants.find(variant => String(variant.id) === this.size.value)?.size || '';
        this.report('');
        this.updateAdd();
        this.offer.syncGiftSelection?.(this.member.handle, this.size.value, true);
      });
      this.add.addEventListener('click', () => {
        const variant = this.member.variants.find(variant => String(variant.id) === this.size.value);
        if (this.add.disabled || !variant?.available || this.submitting) return;
        const color = this.offer.querySelector('[data-fb-gift-color]'), size = this.offer.querySelector('[data-fb-gift-size]');
        if (color.value !== this.member.handle) {color.value = this.member.handle;color.dispatchEvent(new Event('change',{bubbles:true}));}
        size.value = String(variant.id);size.dispatchEvent(new Event('change',{bubbles:true}));
        this.onAdd(this.member,variant);
      });
      const colors = this.dialog.querySelector('[data-fb-preview-colors]');
      this.catalog.products.forEach(product => {
        const button = document.createElement('button');button.type = 'button';button.dataset.handle = product.handle;
        button.setAttribute('aria-pressed','false');
        const image = document.createElement('img');image.src = previewImage(product.image,180);image.alt = '';image.width = 90;image.height = 110;image.loading = 'lazy';
        const label = document.createElement('span');label.textContent = product.color;
        button.append(image,label);button.addEventListener('click', () => this.offer.syncGiftSelection?.(product.handle, '', true));colors.append(button);
      });
    }
    open(trigger) {
      this.create();
      if (!this.dialog) return;
      this.trigger = trigger;
      const chosen = this.offer.querySelector('[data-fb-gift-color]')?.value;
      const product = this.catalog.products.find(item => item.handle === chosen) || this.catalog.products[0];
      if (!product) return;
      if (!this.dialog.open) {
        this.scrollY = window.scrollY;
        this.previousStyles = [
          [document.documentElement,'overflow'],[document.body,'position'],[document.body,'top'],[document.body,'width']
        ].map(([element,property]) => ({element,property,value:element.style.getPropertyValue(property),priority:element.style.getPropertyPriority(property)}));
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';document.body.style.top = `-${this.scrollY}px`;document.body.style.width = '100%';
        this.dialog.showModal();
      }
      trigger.setAttribute('aria-expanded','true');
      this.dialog.querySelector('.fb-gift-preview__body').scrollTop = 0;
      const originalSize = this.offer.querySelector('[data-fb-gift-size]')?.value;
      this.sizeValue = product.variants.find(variant => String(variant.id) === originalSize)?.size || '';
      this.show(product);
      this.dialog.querySelector('.fb-gift-preview__close').focus({preventScroll:true});
    }
    async show(member) {
      if (this.submitting) return;
      const sequence = ++this.sequence;
      this.member = member;this.loadedProduct = null;
      this.report('');this.updateSizes();
      this.dialog.querySelector('[data-fb-preview-selected-color]').textContent = member.color;
      this.dialog.querySelectorAll('[data-fb-preview-section]').forEach(panel => {panel.hidden = true;panel.open = false;});
      this.media.classList.remove('is-zoomed');this.zoom.setAttribute('aria-pressed','false');
      this.gallery.replaceChildren();this.index = 0;this.counter.textContent = '';
      this.previous.disabled = true;this.next.disabled = true;this.zoom.disabled = true;
      this.status.hidden = false;this.status.textContent = this.loadingText;
      this.dialog.querySelectorAll('[data-handle]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.handle === member.handle)));
      const guide = new URL(`${root}pages/ferobrill-size-guide`, location.origin);
      if (member.guide) guide.searchParams.set('guide',member.guide);
      this.dialog.querySelector('[data-fb-preview-guide]').href = guide.href;
      try {
        if (!previewProducts.has(member.handle)) {
          const promise = fetch(`${root}products/${encodeURIComponent(member.handle)}.js`,{credentials:'same-origin',headers:{Accept:'application/json'}})
            .then(response => {if (!response.ok) throw new Error('Preview unavailable');return response.json();})
            .catch(error => {previewProducts.delete(member.handle);throw error;});
          previewProducts.set(member.handle,promise);
        }
        const product = await previewProducts.get(member.handle);
        if (sequence !== this.sequence || !this.dialog.open) return;
        const images = (product.images || []).map(image => previewImage(image)).filter(Boolean);
        if (!images.length && member.image) images.push(previewImage(member.image));
        images.forEach((source,index) => {
          const slide = document.createElement('div');slide.className = 'fb-gift-preview__slide';
          const image = document.createElement('img');image.src = source;image.alt = `${product.title} · ${member.color} · ${index + 1} / ${images.length}`;
          image.width = 800;image.height = 1000;image.loading = index === 0 ? 'eager' : 'lazy';image.decoding = 'async';
          slide.append(image);this.gallery.append(slide);
        });
        this.gallery.scrollLeft = 0;this.status.hidden = true;this.zoom.disabled = !images.length;this.updateCount();
        this.loadedProduct = product;this.updateSizes();
        const content = giftDescriptionSections(product.description,product.title);
        const paragraphs = (selector, lines) => {
          const container = this.dialog.querySelector(selector);container.replaceChildren();
          lines.forEach(text => {const paragraph = document.createElement('p');paragraph.textContent = text;container.append(paragraph);});
        };
        const bullets = (selector, lines) => {
          const container = this.dialog.querySelector(selector);container.replaceChildren();
          lines.forEach(text => {const item = document.createElement('li');item.textContent = text;container.append(item);});
        };
        paragraphs('[data-fb-preview-description]',content.description);
        paragraphs('[data-fb-preview-materials]',content.materials);
        paragraphs('[data-fb-preview-composition]',content.composition.flatMap(line => line.split('\n')).filter(line => line.trim()));
        bullets('[data-fb-preview-details]',content.details);
        bullets('[data-fb-preview-care]',content.care);
        this.dialog.querySelector('[data-fb-preview-composition-wrap]').hidden = !content.composition.length;
        this.dialog.querySelector('[data-fb-preview-care-wrap]').hidden = !content.care.length;
        this.dialog.querySelectorAll('[data-fb-preview-section]').forEach(panel => {panel.hidden = !content[panel.dataset.fbPreviewSection].length && !(panel.dataset.fbPreviewSection === 'details' && content.composition.length) && !(panel.dataset.fbPreviewSection === 'materials' && content.care.length);});
      } catch {
        if (sequence !== this.sequence || !this.dialog.open) return;
        this.status.hidden = false;this.status.textContent = this.dialog.dataset.error;
      }
    }
    updateSizes() {
      const preferred = this.sizeValue;
      this.size.replaceChildren(new Option(this.catalog.selectSize,''));
      for (const variant of this.member.variants) {
        const live = this.loadedProduct?.variants?.find(item => String(item.id) === String(variant.id));
        const option = new Option(variant.size,String(variant.id));
        option.disabled = !variant.available || (this.loadedProduct && !live?.available);
        if (variant.size === preferred && !option.disabled) option.selected = true;
        this.size.add(option);
      }
      this.sizeValue = this.member.variants.find(variant => String(variant.id) === this.size.value)?.size || '';
      this.updateAdd();
    }
    updateAdd() {
      const variant = this.loadedProduct?.variants?.find(item => String(item.id) === this.size.value);
      this.add.disabled = this.submitting || !variant?.available;
    }
    setBusy(value) {
      this.submitting = value;
      if (!this.dialog) return;
      this.size.disabled = value;
      this.dialog.querySelectorAll('[data-fb-preview-colors] button,[data-fb-preview-close]').forEach(button => {button.disabled = value;});
      this.add.toggleAttribute('aria-busy',value);this.updateAdd();
    }
    report(text) {if (this.dialog) this.dialog.querySelector('[data-fb-preview-feedback]').textContent = text;}
    sync(handle, variantId = '') {
      if (!this.dialog?.open || this.submitting) return;
      const product = this.catalog.products.find(item => item.handle === handle);
      if (!product) return;
      const variant = product.variants.find(item => String(item.id) === String(variantId));
      this.sizeValue = variant?.size || '';
      if (this.member?.handle !== product.handle) {
        this.show(product);
        return;
      }
      this.updateSizes();
    }
    updateCount() {
      const length = this.gallery.children.length;
      this.index = Math.min(Math.max(Math.round(this.gallery.scrollLeft / (this.gallery.clientWidth || 1)),0), Math.max(length - 1,0));
      this.counter.textContent = length ? `${this.index + 1} / ${length}` : '';
      this.previous.disabled = !length || this.index === 0;this.next.disabled = !length || this.index === length - 1;
    }
    move(direction) {
      this.media.classList.remove('is-zoomed');this.zoom.setAttribute('aria-pressed','false');
      this.gallery.scrollTo({left:(this.index + direction) * this.gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    close(force = false) {
      if (this.submitting && !force) return;
      if (this.dialog?.open) {this.sequence++;this.dialog.close();this.restore();}
    }
    restore() {
      if (!this.previousStyles) return;
      for (const {element,property,value,priority} of this.previousStyles || []) {
        if (value) element.style.setProperty(property,value,priority);else element.style.removeProperty(property);
      }
      this.previousStyles = null;
      if (Number.isFinite(this.scrollY)) window.scrollTo({top:this.scrollY,behavior:'instant'});
      this.offer.querySelectorAll('[data-fb-gift-view]').forEach(button => button.setAttribute('aria-expanded','false'));
      if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
    }
    destroy() {this.close(true);this.dialog?.remove();}
  }

  customElements.define('fb-gift-offer', class extends HTMLElement {
    connectedCallback() {
      const catalogElement = this.querySelector('[data-fb-gift-catalog]');
      const color = this.querySelector('[data-fb-gift-color]');
      const select = this.querySelector('[data-fb-gift-size]');
      const feedback = this.querySelector('[data-fb-gift-feedback]');
      const confirm = this.querySelector('[data-fb-gift-confirm]');
      const image = this.querySelector('.fb-gift-offer__image');
      if (!catalogElement || !color || !select || !feedback || !confirm || select.dataset.initialized) return;
      let catalog;
      try { catalog = JSON.parse(catalogElement.textContent); } catch { return; }
      select.dataset.initialized = 'true';
      const populateSelection = (handle, variantId = '') => {
        const product = catalog.products.find(item => item.handle === handle);
        color.value = product?.handle || '';
        feedback.textContent = '';
        confirm.disabled = true;
        select.replaceChildren(new Option(product ? catalog.selectSize : catalog.selectColorFirst, ''));
        select.disabled = !product;
        if (!product) return;
        for (const variant of product.variants) {
          const option = new Option(variant.size, String(variant.id));
          option.disabled = !variant.available;
          select.add(option);
        }
        const selectedVariant = product.variants.find(item => String(item.id) === String(variantId) && item.available);
        if (selectedVariant) select.value = String(selectedVariant.id);
        confirm.disabled = !selectedVariant;
        if (image && product.image) { image.removeAttribute('srcset'); image.src = product.image; image.alt = product.color; }
      };
      this.syncGiftSelection = (handle, variantId = '', emit = false) => {
        populateSelection(handle, variantId);
        this.giftPreview?.sync(handle, variantId);
        if (emit) broadcastSelection(this, handle, variantId);
      };
      this._giftSelectionListener = event => {
        if (event.detail?.source === this) return;
        this.syncGiftSelection(event.detail?.handle || '', event.detail?.variantId || '', false);
      };
      document.addEventListener(selectionEvent, this._giftSelectionListener);
      color.addEventListener('change', () => this.syncGiftSelection(color.value, '', true));
      select.addEventListener('change', () => {
        const product = catalog.products.find(item => item.handle === color.value);
        const variant = product?.variants.find(item => String(item.id) === select.value);
        confirm.disabled = !variant?.available;
        feedback.textContent = '';
        broadcastSelection(this, color.value, select.value);
        this.giftPreview?.sync(color.value, select.value);
      });
      const addGift = async (product, variant) => {
        if (!variant?.available || busy) return;
        busy = true;
        this.giftPreview?.setBusy(true);
        const report = text => {feedback.textContent = text;this.giftPreview?.report(text);};
        const finish = async () => {
          this.giftPreview?.setBusy(false);this.giftPreview?.close();
          await refresh();
          if (this.classList.contains('fb-gift-offer--product')) document.querySelector('[data-js-site-cart-sidebar]')?.show();
        };
        confirm.disabled = true;
        color.disabled = true;
        select.disabled = true;
        confirm.setAttribute('aria-busy', 'true');
        let added = false;
        try {
          let cart = await request('cart.js');
          if (cart.currency !== 'USD' || eligibleTotal(cart) < 22500) { report(catalog.messages.minimum); return; }
          const existing = cart.items.filter(isGift);
          if (existing.length === 1 && existing[0].variant_id === variant.id && hasFreeGift(cart)) { report(catalog.messages.added);await finish();return; }
          const codes = (cart.discount_codes || []).map(item => item.code).filter(code => code.toUpperCase() !== giftCode);
          cart = await removeGifts(cart);
          await request('cart/add.js', {items: [{id: variant.id, quantity: 1, properties: {_fb_regent_gift: '1'}}]});
          added = true;
          cart = await request('cart/update.js', {discount: [...codes, giftCode].join(',')});
          if (!hasFreeGift(cart)) {
            await removeGifts(cart);
            added = false;
            await request('cart/update.js', {discount: codes.join(',')});
            report(catalog.messages.unavailable);
          } else {report(catalog.messages.added);await finish();}
        } catch (error) {
          let cleaned = !added;
          if (added) {
            try { await removeGifts(await request('cart.js')); await refresh(); cleaned = true; } catch {}
          }
          report(catalog.messages.error);
          if (!cleaned) window.location.assign(`${root}cart`);
        } finally {
          busy = false;
          this.giftPreview?.setBusy(false);
          confirm.disabled = !catalog.products.find(item => item.handle === color.value)?.variants.find(item => String(item.id) === select.value)?.available;
          color.disabled = false;
          select.disabled = false;
          confirm.removeAttribute('aria-busy');
        }
      };
      this.giftPreview = new GiftPreview(this,catalog,addGift);
      confirm.addEventListener('click', () => {
        const product = catalog.products.find(item => item.handle === color.value);
        addGift(product,product?.variants.find(item => String(item.id) === select.value));
      });
      const savedProduct = catalog.products.find(product => product.variants.some(variant => String(variant.id) === String(catalog.selectedVariant)));
      const sharedProduct = catalog.products.find(product => product.handle === sharedSelection.handle);
      if (sharedProduct) {
        this.syncGiftSelection(sharedProduct.handle, sharedSelection.variantId, false);
      } else if (savedProduct) {
        this.syncGiftSelection(savedProduct.handle, String(catalog.selectedVariant), false);
        sharedSelection.handle = savedProduct.handle;
        sharedSelection.variantId = String(catalog.selectedVariant);
      }
    }
    disconnectedCallback() {
      document.removeEventListener(selectionEvent, this._giftSelectionListener);
      this.giftPreview?.destroy();
    }
  });
})();


